import { create } from 'zustand';

import { cropConnectApiClient } from '../services/cropConnectApiClient';

export interface BeetPriceDto {
  year: number;
  averagePrice: number | null;
}

interface BeetPriceState {
  beetPrices: BeetPriceDto[];
  isLoading: boolean;
  error: string | null;
  getBeetPrices: () => Promise<void>;
  clearData: () => void;
}

export const useBeetPriceStore = create<BeetPriceState>((set) => ({
  beetPrices: [],
  isLoading: false,
  error: null,

  getBeetPrices: async () => {
    set({ isLoading: true });
    try {
      const response = await cropConnectApiClient.getAverageBeetPriceDataBox();
      const dataBox = response.data;
      if (dataBox) {
        const mappedPrices = (dataBox.averagePrices || []).map((p) => ({
          year: p.year ?? 0,
          averagePrice: p.price ?? null,
        }));
        set({
          beetPrices: mappedPrices,
          error: null,
        });
      } else {
        set({ error: 'No data in BeetPrice response' });
      }
    } catch (err) {
      set({
        error: err instanceof Error ? err.message : 'An error occurred',
      });
    } finally {
      set({ isLoading: false });
    }
  },

  clearData: () => {
    set({
      beetPrices: [],
      error: null,
    });
  },
}));
